<template>
  <div :class="websiteFormat === 'all_items' ? 'mt-16' : 'mt-4'">
    <NavigationSwiper
      :fixed="true"
      :menuItems="menuItems"
      v-if="websiteFormat === 'all_items'"
    />
    <v-row
      v-for="(items, section) in menuItems"
      :id="slug(section.replace(/^\d/, 'abc$&'))"
      :key="section.replace(/^\d/, 'abc$&')"
      class="background-color-white mb-3"
      no-gutters
    >
      <v-col cols="12">
        <div class="pl-4 py-2">
          <h4 class="font-weight-medium">{{ section }}</h4>
        </div>
      </v-col>
      <v-col cols="12">
        <v-sheet :max-width="fixedRowWidth">
          <swiper :options="{ slidesPerView: 2.5 }">
            <swiper-slide
              class="d-flex justify-center"
              v-for="item in menuItems[section]"
              :key="item.upc"
            >
              <Product :product="item" :size="'xs'" />
            </swiper-slide>
          </swiper>
        </v-sheet>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { slug } from "github-slugger";
import Product from "@/components/Product/index.vue";
import NavigationSwiper from "@/components/Navigation/Xs/Swiper.vue";
import { mapState } from "vuex";

export default {
  name: "XsMenu",
  components: { Product, NavigationSwiper },
  computed: {
    ...mapState({
      websiteFormat: (state) =>
        state.store.info.store_info.customization?.website.style
          .website_format ?? "all_items",
    }),
    fixedRowWidth() {
      return this.innerWidth;
    },
  },
  created() {
    window.addEventListener("resize", this.setInnerWidth);
  },
  data() {
    return {
      innerWidth: window.innerWidth,
    };
  },
  destroyed() {
    window.removeEventListener("resize", this.setInnerWidth);
  },
  methods: {
    setInnerWidth(event) {
      this.innerWidth = event.target.innerWidth;
    },
    slug,
  },
  props: { menu: Object, menuItems: Object },
};
</script>
<style scoped>
.mt-16 {
  margin-top: 64px;
}
</style>
